export const REVIEW_CATEGORIES = {
  REGGORA: 'reggora',
  UCDP: 'ucdp',
  EAD: 'ead',
  WARRANTY: 'warranty',
}
